import { request } from "../utils/request.js"

export const tenantPersonalConfig_findForCurrentTenant = (args) => request({
    url: 'tenantPersonalConfig/findForCurrentTenant',
    method: 'GET',
    showFailMessage: true,
    ...args
})

export const tenantPersonalConfig_updateValue = (pojo, args) => request({
    url: 'tenantPersonalConfig/updateValue',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const tenantPersonalConfig_updateValueBatch = (pojo, args) => request({
    url: 'tenantPersonalConfig/updateValueBatch',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})


// 通过code获取配置项
export const tenantPersonalConfig_findByCode = (code, args) => request({
    url: 'tenantPersonalConfig/findByCode',
    method: 'GET',
    params: { code },
    showFailMessage: true,
    ...args
})

// 通过code获取配置项清单
export const tenantPersonalConfig_findByCodeIn = (pojo, args) => request({
    url: 'tenantPersonalConfig/findByCodeIn',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/tenantPersonalConfig.js